import axios from '@/axios'

export default {
  fetchAll(params, id){
    return axios.get(`/stock-opname-details/all/${id}`, {params})
  },
  fetchLimit(params, id){
    return axios.get(`/stock-opname-details/limit/${id}`, {params})
  },  
  fetchById(id){
    return axios.get(`/stock-opname-details/${id}`)
  },    
  create(payload){
    return axios.post(`/stock-opname-details`, payload)
  },
  update(id, payload){
    return axios.put(`/stock-opname-details/${id}`, payload)
  },
  delete(id){
    return axios.delete(`/stock-opname-details/${id}`)
  }, 
  deleteMultiple(payload){
    return axios.delete(`/stock-opname-details`, payload)
  }
}